import React, { useRef } from 'react';
import { InputNumber } from 'antd';
import { SeparateNumberFormat } from '../../../services/utils';
import i18n from 'i18next';

import Colors from '../../../themes/Colors';
const currencyInputContainerStyle = {
  display: 'flex',
  alignItems: 'center',
  position: 'relative'
};

const currencySymbolStyle = {
  position: 'absolute',
  left: '7px',
  color: Colors.textMuted,
  fontSize: '12px',
  pointerEvents: 'none',
  zIndex: 5
};

const inputGroupStyle = {
  textAlign: 'center',
  paddingLeft: '36px',
  width: '100%'
};

const CustomInputCurrency = ({
  currency,
  value,
  onChange,
  disabled,
  step,
  style,
  max,
  commitOnBlur
}) => {
  // A ref, not state: with commitOnBlur nothing is committed while the field is
  // focused, so `value` stays put and the input keeps the user's own text.
  const pendingValue = useRef(undefined);

  const handleInputChange = newValue => {
    if (commitOnBlur) {
      pendingValue.current = newValue;
      return;
    }
    if (newValue === null) return;
    onChange(newValue);
  };

  // Nothing is reported when the user leaves the field untouched.
  const commitPendingValue = () => {
    const pending = pendingValue.current;
    pendingValue.current = undefined;
    if (pending === undefined || pending === null || pending === '') return;
    onChange(pending);
  };

  const formatStep = stepValue => {
    if (stepValue === undefined || stepValue === null) {
      return 1;
    }
    const stepString = String(stepValue).replace(',', '.');
    const parsedStep = parseFloat(stepString);
    if (isNaN(parsedStep)) {
      return 1;
    }
    return parseFloat(parsedStep.toFixed(2));
  };

  const parseValue = value => {
    if (!value) return '';

    const isSpanish = i18n.language.substring(0, 2) === 'es';
    let replacedValue;

    if (isSpanish) {
      replacedValue = String(value)
        .replace(/\./g, '')
        .replace(',', '.');
    } else {
      replacedValue = String(value).replace(/,/g, '');
    }

    const parsed = parseFloat(replacedValue);
    if (isNaN(parsed)) {
      return 0;
    }
    return parsed.toFixed(2);
  };

  return (
    <div
      style={{ ...currencyInputContainerStyle }}
      onClick={e => e.stopPropagation()}
      onMouseDown={e => e.stopPropagation()}
    >
      <span style={currencySymbolStyle}>${currency}</span>

      <InputNumber
        type="text"
        formatter={SeparateNumberFormat}
        parser={parseValue}
        disabled={disabled}
        style={{ ...inputGroupStyle, ...style }}
        min={0}
        max={max}
        value={value || 0}
        onChange={handleInputChange}
        onBlur={commitOnBlur ? commitPendingValue : undefined}
        onPressEnter={commitOnBlur ? commitPendingValue : undefined}
        // step={formatStep(step)}
        precision={2}
      />
    </div>
  );
};

export default CustomInputCurrency;
